/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
$(document).ready(function () {
    $(".ProductItem__Info").each(function () {
        var $father = $(this)
        $father.find("label.ColorSwatch").click(function () {
            var $swatchLabel = $(this)
            var $addToCartButton = $father.find('#ad_to_cart')
            $addToCartButton.attr('data-add-to-cart', $swatchLabel.attr('id'))
            $addToCartButton.attr('data-var_id', $swatchLabel.attr('id'))
            $father.find(".Price--highlight").text($swatchLabel.attr('data-price'))
            //$father.find(".Price--compareAt").text($swatchLabel.attr('data-compare-at-price'))
			//$father.find(".Price.Text--subdued").text($swatchLabel.attr('data-price'))
            
            if ($swatchLabel.attr('data-isavailable') == 'true') {
                $addToCartButton.removeAttr('disabled')
                $addToCartButton.text("הוסף לסל")
            } else {
                $addToCartButton.attr('disabled', '')
                $addToCartButton.text("אזל המלאי")
            }
        })
    })
});
//  <span class="ProductItem__Price Price Price--highlight Text--subdued">{{ product.first_available_variant.price | money_without_trailing_zeros }}</span>
//           <span class="ProductItem__Price Price Price--compareAt Text--subdued">
// data-compare-at-price="{{variant_for_value.compare_at_price}}" data-price="{{variant_for_value.price}}"

function addItemToCart(variant_id, qty) {
        data = {
            "id": variant_id,
            "quantity": qty
        }
        jQuery.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: data,
            dataType: 'json',
            success: function () {
                $('.cart_dr').trigger("click");
                $("[data-drawer-id='sidebar-cart']")[1].click()
                document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                    bubbles: true  //this code is for prestige theme, is to refresh the cart
                }));
            }

        });

    }

function ramis(elem){
  var ID = $(elem).attr("data-var_id");
  addItemToCart(ID, 1);  
}